import React from "react";
import axios from 'axios';
import api from "../common/api"
import { Button, CircularProgress, TextField } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import RelatedContactComponent from '../common/vehicles/RelatedContact';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
	checkbox:{
	    width: 8,
	    height: 8,
	},
});

class VehicleKmSubcontact extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        snackbar:{open: false, message:'', severity: 'success'},
        loading: true, 
        saved: false, 
        vehicle:{},
        subcontacts_deleted: [],
        relation_types:[],
        client_subcontacts:[]
      }
      this.addNewItem = this.addNewItem.bind(this)
      this.removeItem = this.removeItem.bind(this)
    }

    async componentDidMount() {
        var vehicle = await this.getVehicle();
        var subcontacts = []
		var related_contacts = []
		vehicle.subcontacts.map((val, idx)=>{
			var subcontact = {subcontact_id: val.subcontact_id, relation_type_id:val.relation_type_id, start_date: val.start_date, end_date:val.end_date, has_car_doc_documents:val.has_car_doc_documents, car_doc_document_number: val.car_doc_document_number, car_doc_documents_due_date: val.car_doc_documents_due_date}
			subcontacts.push(subcontact)
			subcontact.hansa_code = val.hansa_code
			subcontact.id = val.id
			subcontact.firstname = val.subcontact.firstname
			subcontact.lastname = val.subcontact.lastname
			related_contacts.push(subcontact)
		})
		if (subcontacts.length === 0){
			subcontacts.push({subcontact_id:'', 'relation_type_id':'', 'start_date':'', 'end_date':'', 'has_car_doc_documents':'', car_doc_document_number: '', car_doc_documents_due_date: ''})
		}
		if (related_contacts.length === 0){
			related_contacts.push({subcontact_id:'', 'relation_type_id':'', 'start_date':'', 'end_date':'', 'has_car_doc_documents':'', car_doc_document_number: '', car_doc_documents_due_date: ''})
		}
        subcontacts.subcontact_ids = related_contacts
        vehicle.subcontacts = subcontacts
		var client_id = null
		if (vehicle.contract_id){
			 client_id = vehicle.contract.contact_id
		}
        console.log('vehicle.active_booking!',vehicle.active_booking, vehicle)
		if (vehicle.active_booking && vehicle.active_booking[0]){
			client_id = vehicle.active_booking[0].client.contact_id
		}
        var client_subcontacts = await this.getClientSubcontacts(client_id)
        console.log('client_subcontacts!', client_subcontacts)
        if (client_subcontacts.length === 0)
            client_subcontacts = await this.getAcUsers();
        var relation_types = await this.getRelationsTypes()
        vehicle.min_last_km = vehicle.last_km
        vehicle.km_confirmed = false

        this.setState({vehicle: vehicle, client_subcontacts: client_subcontacts, relation_types: relation_types, loading: false})
    }

    handleDialog(e){
        e.preventDefault();
        this.props.handleKmDialog()
    }
    
    getVehicle(){
		const token =localStorage.getItem('userToken')
        const url = api.vehicles().get(this.props.id)
        return axios
		     .get(url,{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		          res.data = Object.values(res.data);
		          return res.data[0]
		      })
		      .catch(err =>{console.log(err)
            })
	    
    }

    getClientSubcontacts(client_id){
		const token =localStorage.getItem('userToken')
        const url = api.subcontacts().all(client_id)
        return axios
		     .get(url,{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		          res.data = Object.values(res.data);
		          return res.data
		      })
		      .catch(err =>{console.log(err)
            })
    }

    getAcUsers = () => {
		const token =localStorage.getItem('userToken')
        const url = api.mobileUsers().index()
        return axios
		     .get(url,{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
                  res.data.map((val, idx)=>{
                      val.firstname = val.subcontact.firstname
                      val.lastname = val.subcontact.lastname
                      val.contact = {email: ''}
                      val.contact.email = val.subcontact.contact.email
                      val.license_due_date = val.subcontact.license_due_date
                      val.id = val.subcontact.id
                      val.user_id = val.id
                      return val;
                    })
                  return res.data
		      })
		      .catch(err =>{console.log(err)
            })

    }

    getRelationsTypes(){
		const token =localStorage.getItem('userToken')
        const url = api.vehicles().subcontact_relation_types()
        return axios
		     .get(url,{ headers: {"Authorization" : `Bearer ${token}`} })
		      .then(res => {
		          res.data = Object.values(res.data);
		          return res.data
		      })
		      .catch(err =>{console.log(err)
            })
    }


    addNewItem(mod){
        var vehicle = this.state.vehicle
        vehicle.subcontacts.subcontact_ids.push({subcontact_id: '', 'relation_type_id':'', 'start_date':new Date().toISOString().slice(0, 10), 'end_date':'', 'has_car_doc_documents':''})
        vehicle.subcontacts.subcontact_ids.map((val)=>{
            if (val.subcontact_id > 0){
                if (!val.end_date || val.end_date === ''){
                    val.end_date = new Date().toISOString().slice(0, 10)
                    return val;
                }
            }
        })
        this.setState({vehicle: vehicle})
    
    }
    removeItem(mod, id){
        var { vehicle, subcontacts_deleted }= this.state
        subcontacts_deleted.push(vehicle.subcontacts.subcontact_ids[id])
        vehicle.subcontacts.subcontact_ids = vehicle.subcontacts.subcontact_ids.filter((s, sidx) => id !== sidx);
        this.setState({vehicle: vehicle, subcontacts_deleted: subcontacts_deleted})
    }
    handleChange = async (event, mod) => {
        var key = event.target.name
        var val = event.target.value
        var state = this.state
        switch (mod){
            case 'related_contact':
				var res = event.target.name.split(".");
			    key = res[0];
			    var id = res[1];
			    if (key === 'relation_type_id'){
					state.vehicle.subcontacts.subcontact_ids[id].relation_type_id = val
			    } else if (key ==='start_date') {
					state.vehicle.subcontacts.subcontact_ids[id].start_date = val
			    } else if (key ==='end_date') {
					state.vehicle.subcontacts.subcontact_ids[id].end_date = val
			    } else if (key ==='has_car_doc_documents') {
					state.vehicle.subcontacts.subcontact_ids[id].has_car_doc_documents = val
			    } else if (key ==='subcontact_id') {
					state.vehicle.subcontacts.subcontact_ids[id].subcontact_id = val
			    } else if (key ==='car_doc_documents_due_date') {
					state.vehicle.subcontacts.subcontact_ids[id].car_doc_documents_due_date = val
			    } else if (key ==='car_doc_document_number') {
					state.vehicle.subcontacts.subcontact_ids[id].car_doc_document_number = val
			    }
            break;
            case 'last_km':
                state.vehicle.last_km = val;
            break;
            case 'last_km_date':
                state.vehicle.last_km_date = val;
            break;
            case 'km_confirmed':
                state.vehicle.km_confirmed = event.target.checked
            break;
    
        };
        this.setState({state})
        
    }
    handleSubmit = (e) => {
	    var formData = new FormData();
        formData.append('_method', 'patch');
	    formData.set("vehicle[plate]", this.state.vehicle.plate.toUpperCase());
	    formData.set("vehicle[id]", this.state.vehicle.id);
	    formData.set("vehicle[last_km]", (this.state.vehicle.last_km) ? this.state.vehicle.last_km :'');
	    formData.set("vehicle[last_km_origin]", 'EFLEET');
	    formData.set("vehicle[last_km_date]", (this.state.vehicle.last_km_date) ? this.state.vehicle.last_km_date :'');

	    var subcontact_idx = 0;
	    this.state.vehicle.subcontacts.subcontact_ids.map((val, idx)=>{
	    	if (val.subcontact_id !== '' && val.relation_type_id !=='' ){
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][subcontact_id]", val.subcontact_id);
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][relation_type_id]", val.relation_type_id);
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][start_date]", (val.start_date) ? val.start_date : '');
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][end_date]", (val.end_date) ? val.end_date : '');
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][has_car_doc_documents]", val.has_car_doc_documents);
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][car_doc_documents_due_date]", (val.car_doc_documents_due_date) ? val.car_doc_documents_due_date : '' );
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][car_doc_document_number]", (val.car_doc_document_number) ? val.car_doc_document_number : '');
			    subcontact_idx++;
	    	}
	    })

	    this.state.subcontacts_deleted.map((val, idx)=>{
	    	if (val.subcontact_id !== '' && val.relation_type_id !=='' && this.state.vehicle_id ){
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][subcontact_id]", val.subcontact_id);
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][relation_type_id]", val.relation_type_id);
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][start_date]", val.start_date);
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][end_date]", (val.end_date) ? val.end_date : new Date().toISOString().slice(0, 19).replace('T', ' '));
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][has_car_doc_documents]", val.has_car_doc_documents);
			    formData.set("vehicle[subcontacts]["+ subcontact_idx +"][deleted_at]", new Date().toISOString().slice(0, 19).replace('T', ' '));
			    subcontact_idx++;
	    	}
	    })
		let self = this
		const token =localStorage.getItem('userToken')
        axios.post(api.vehicles().patch(this.state.vehicle.id),
            formData,
            {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
            )
        .then((response)=> {
            var snackbar = {open: true, message: 'Vehículo modificado con éxito', severity: 'success'}
            self.setState({snackbar: snackbar, saved: true})
//            this.handleDialog()
        })
        .catch(function (error) {
            var snackbar = {open: true, message: 'No se pudo modificar el vehículo. Por favor reintentar.', severity: 'error'}
            self.setState({snackbar: snackbar})
        })
    }
    render(){
        const { vehicle, subcontacts } = this.state
		const classes = this.props.classes;
        return(
            <React.Fragment>
             <Dialog
                open={this.props.open}
                onClose={(e)=>this.handleDialog(e)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xl"
                >
                <DialogTitle id="alert-dialog-title">Vehículo {this.props.plate}</DialogTitle>
                <DialogContent>
                {this.state.loading && <CircularProgress />}    
                {!this.state.loading && <DialogContentText id="alert-dialog-description">
                <TextField
                            id="min_last_km"
                            name="min_last_km"
                            label="Últ. KM reportado"
                            type="number"
                            disabled
                            placeholder="Ingrese el último km"
                            value={vehicle.min_last_km}
                            margin="normal"
                            className="mr-2 "
                            InputLabelProps={{
                                shrink: true
                            }}
                            inputProps={{
                                style:{minWidth: 100, fontSize: '0.75rem'},
                            }} 
                    />

                    <TextField
                            id="last_km"
                            name="last_km"
                            label="Nuevo KM"
                            type="number"
                            placeholder="Ingrese el último km"
                            helperText={((vehicle.min_last_km > vehicle.last_km) && !vehicle.km_confirmed) ? 'El km debe ser superior al actual  o confirme el km.' : ''}
                            error={((vehicle.min_last_km > vehicle.last_km)  && !vehicle.km_confirmed) ? 'El km debe ser superior al actual o confirme el km.' : ''}
                            onChange={(e) => {this.handleChange(e, 'last_km')}}
                            value={vehicle.last_km}
                            margin="normal"
                            className="mr-2 "
                            InputLabelProps={{
                                shrink: true
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">
                                                    <Typography variant="caption" style={{width: 70}}>KM Actual</Typography>
                                                    <Checkbox
                                                        id="km_confirmed"
                                                        name="km_confirmed"
                                                        className={classes.checkbox}
                                                        onChange={(e) => {this.handleChange(e, 'km_confirmed')}}
                                                        value={vehicle.km_confirmed}
                                                        checked={vehicle.km_confirmed}
                                                        color="primary"
                                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                    />			            				
                                                </InputAdornment>,
                            }}
                            inputProps={{
                                style:{minWidth: 100, fontSize: '0.75rem'},
                                min: vehicle.min_last_km
                            }} 
                    />
                    <TextField
                            id="last_km_date"
                            name="last_km_date"
                            label="Últ. Fecha KM"
                            type="date"
                            placeholder="Ingrese la última fecha de km"
                            onChange={(e) => {this.handleChange(e, 'last_km_date')}}
                            value={vehicle.last_km_date}
                            margin="normal"
                            className="mr-2 "
                            InputLabelProps={{
                            shrink: true
                            }}
                            inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
                    />
                    {!this.state.loading && <RelatedContactComponent onChange={this.handleChange} disabled={false} error={[]}
                        title={'Contactos relacionados'} related_contact={this.state.vehicle.subcontacts}
                        subcontacts={this.state.client_subcontacts} subcontact_relation_types={this.state.relation_types} 
                        addNewItem={this.addNewItem}
                        removeItem={this.removeItem} 
                        is_fleet_owner={this.state.vehicle.is_fleet_owner}
                    />}

                </DialogContentText>}
                </DialogContent>
                <DialogActions>
                    {(!this.state.saved)?
                        <>
                        <Button
                            variant="contained"
                            className="mt-3 ml-1 mr-1" 
                            color="secondary"
                            onClick={(e) => {this.handleDialog(e)}} >
                                Cancelar
                        </Button>

                        <Button disabled={((this.state.vehicle.min_last_km > this.state.vehicle.last_km) && !this.state.vehicle.min_last_km > this.state.vehicle.km_confirmed)} onClick={(e) => {this.handleSubmit(e)}} variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
                            Guardar
                        </Button>
                    </>
                    :
                        <Button onClick={(e) => {this.handleDialog(e)}} variant="contained" className="mt-3 ml-1 mr-1"  color="primary">
                            Volver
                        </Button>
                    }
                </DialogActions>
              </Dialog>
              <Snackbar open={this.state.snackbar.open} autoHideDuration={1000} onClose={this.handleCloseSuccess}>
					<Alert onClose={this.handleCloseSuccess} severity={this.state.snackbar.severity}>
					  {this.state.snackbar.message}
					</Alert>
				</Snackbar>
            </React.Fragment>
        )
    }
}

export default withStyles(useStyles)(VehicleKmSubcontact);